import React, { useState, useEffect, useContext } from 'react'
import useApi from 'hooks/useApi'
import messages from './messages'
import { FormattedTime, FormattedDate, FormattedMessage, useIntl } from 'react-intl'
import { useKeyboardShortcut } from '@arnsbogroup/react-voicearchive/lib/hooks'
import { DataTable } from '@arnsbogroup/react-voicearchive'

const Span = ({ children }) => <span>{ children }</span>
const DateSpan = ({ children }) => <span className="space-x-2">
  <FormattedDate value={new Date(children * 1000)} />
  <FormattedTime value={new Date(children * 1000)} />
</span>

const IncidentsPane = ({ match, location }) => {
  const { formatMessage } = useIntl()
  const [entries] = useApi(`/orderjobdisplay/incidents.json?orderId=${match.params.orderId}`)

  return (
    <DataTable
      className="w-full h-full table-auto"
      entries={entries}
      head={{
        reporter: { label: 'Reporter' },
        foundBy: { label: 'Identified By' },
        taskIds: { label: 'Task IDs' },
        errorLevel: { label: 'Error Level' },
        comment: { label: 'Comment' },
        reportedAt: { label: 'Reported At' },
      }}
      body={{
        reporter: Span,
        foundBy: Span,
        taskIds: ({ children }) => <span>{ children.join(', ') }</span>,
        errorLevel: Span,
        comment: Span,
        reportedAt: Span,
      }}
    />
  )
}

export default IncidentsPane
